import React                         from 'react';
import { observer }                  from 'mobx-react';
import { PlusOutlined }              from '@ant-design/icons';
import AdvertiserModel               from 'models/AdvertiserModel';
import AdvertiserShowModel           from 'models/AdvertiserShowModel';
import { ApiCollection }             from 'collections/ApiCollection';
import { privateLayoutStore }        from 'stores/index';
import { messageErrorIntl }          from 'utils/messageIntl';
import { messageSuccessIntl }        from 'utils/messageIntl';
import { AppForm }                   from 'components/App/AppForm';
import AdvertiserShowForm            from 'forms/AdvertiserShowForm';
import { Button }                    from 'antd';
import AdvertiserShowComponent       from './AdvertiserShowComponent';
import FormattedMessageWrapper       from 'components/App/FormattedMessageWrapper';
import CardBox                       from 'components/App/CardBox';
import { showDashboardStore }        from 'stores/index';
import rights                        from 'utils/rights';

@observer
class ShowDashboardAdvertiserShowsBox extends React.Component {
  public advertiserCollection: ApiCollection<AdvertiserModel>;

  constructor(props: any) {
    super(props);

    this.advertiserCollection = new ApiCollection(AdvertiserModel);
    this.advertiserCollection.setFilters({
      itemsPerPage: 1000,
      'order[name]': 'asc',
      // pagination: false,
    });
  }

  public componentDidMount() {
    this.advertiserCollection.list();
  }

  public render() {
    const {
      advertiserShowCollection,
      showModel,
    } = showDashboardStore;

    return (
      <CardBox
        // className="ShowDashboardAdvertiserShowsBox__container"
        content={
          <div className="ShowDashboardAdvertisersBox__advertisers">
            {advertiserShowCollection.map((advertiserShow: AdvertiserShowModel) => (
              <AdvertiserShowComponent
                advertiserCollection={this.advertiserCollection}
                advertiserShow={advertiserShow}
                deleteAdvertiserShow={this.deleteAdvertiserShow}
                key={advertiserShow.get('@id')}
                onSuccess={() => {
                  advertiserShowCollection.list();
                  privateLayoutStore.fetchAdvertisingData()
                }}
              />
            ))}
          </div>
        }
        extra={
          rights.for.advertiser.add ? (
            <div className="ShowDashboardAdvertiserShowsBox__addAction">
              <Button
                htmlType="button"
                icon={<PlusOutlined />}
                onClick={event => {
                  event.stopPropagation();
                  AppForm.open(AdvertiserShowForm, {
                    advertiserCollection: this.advertiserCollection,
                    model: new AdvertiserShowModel({ show: showModel.path }),
                    onSuccess: () => {
                      advertiserShowCollection.list();
                      privateLayoutStore.fetchAdvertisingData();
                    },
                  }, {
                    title: <FormattedMessageWrapper id="Ajouter une annonce" />,
                  });
                }}
              />
            </div>
          ) : null
        }
        loading={!advertiserShowCollection.isLoaded || advertiserShowCollection.isLoading}
        title={<FormattedMessageWrapper id="Annonces" />}
      />
    );
  }

  private deleteAdvertiserShow = (advertiserShowModel: AdvertiserShowModel) => {
    const { advertiserShowCollection } = showDashboardStore;
    advertiserShowModel
      .destroy()
      .then(() => {
        messageSuccessIntl("Suppression réussie !");
        advertiserShowCollection.list();
        privateLayoutStore.fetchAdvertisingData()
      })
      .catch(() => {
        messageErrorIntl("Impossible de supprimer.");
      });
  };
}

export default ShowDashboardAdvertiserShowsBox;
